import { CssModule } from '../common/InternalTypes';

export default class CssModuleFactory {
	static async getCssModule(): Promise<CssModule> {
		return await import('./theme.module.lazy.css');
	}
}
